import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题;
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/login",
      meta: {
        title: "杭州市上城区事业单位公开招聘网上报名系统登录"
      },
      name: "Login",
      component: () => import("@/view/login/Login")
    },
    {
      path: "/register",
      meta: {
        title: "杭州市上城区事业单位公开招聘网上报名系统注册"
      },
      name: "Register",
      component: () => import("@/view/register/Register")
    },
    // 门户网站
    {
      path: "/home",
      meta: {
        title: "杭州市上城区事业单位公开招聘网上报名系统门户"
      },
      redirect: "/home/index",
      component: () => import("@/view/home/Home"),
      children: [
        {
          path: "/home/index",
          name: "Index",
          meta: {
            title: "杭州市上城区事业单位公开招聘网上报名系统门户"
          },
          component: () => import("@/view/home/index/Index")
        },
        {
          path: "/home/person",
          name: "Person",
          meta: {
            title: "杭州市上城区事业单位公开招聘网上报名系统门户"
          },
          component: () => import("@/view/person/Person")
        },
        {
          path: "/home/showAll",
          name: "ShowAll",
          meta: {
            title: "杭州市上城区事业单位公开招聘网上报名系统门户"
          },
          component: () => import("@/view/showAll/ShowAll")
        }
      ]
    },
    // 单场考试
    {
      path: "/apply",
      name: "apply",
      meta: {
        title: "杭州市上城区事业单位公开招聘网上报名系统"
      },
      redirect: "/apply/examInfo",
      component: () => import("@/view/apply/Apply"),
      children: [
        {
          path: "/apply/examInfo",
          name: "ExamInfo",
          meta: {
            title: "杭州市上城区事业单位公开招聘网上报名系统"
          },
          component: () => import("@/view/apply/ExamInfo")
        },
        {
          path: "/apply/guide",
          name: "Guide",
          meta: {
            title: "杭州市上城区事业单位公开招聘网上报名系统"
          },
          component: () => import("@/view/apply/Guide")
        },
        {
          path: "/apply/applyProcess",
          name: "ApplyProcess",
          redirect: "/apply/applyCommitment",
          meta: {
            title: "杭州市上城区事业单位公开招聘网上报名系统"
          },
          component: () => import("@/view/apply/ApplyProcess"),
          children: [
            // 承诺书
            {
              path: "/apply/applyCommitment",
              name: "Commitment",
              component: () => import("@/view/apply/applyPages/Commitment"),
              meta: { keepAlive: true, title: "杭州市上城区事业单位公开招聘网上报名系统" }
            },
            // 基本信息
            {
              path: "/apply/applyBaseInfo",
              name: "BaseInfo",
              component: () => import("@/view/apply/applyPages/BaseInfo"),
              meta: { keepAlive: false, title: "杭州市上城区事业单位公开招聘网上报名系统" }
            },
            // 教育经历
            {
              path: "/apply/graduate",
              name: "Graduate",
              component: () => import("@/view/apply/applyPages/Graduate"),
              meta: { keepAlive: false, title: "杭州市上城区事业单位公开招聘网上报名系统" }
            },
            // 证件资料
            {
              path: "/apply/certificateInfo",
              name: "CertificateInfo",
              component: () =>
                import("@/view/apply/applyPages/CertificateInfo"),
              meta: { keepAlive: false, title: "杭州市上城区事业单位公开招聘网上报名系统" }
            },
            // 审核
            {
              path: "/apply/applyCheckApply",
              name: "CheckApply",
              component: () => import("@/view/apply/applyPages/CheckApply"),
              meta: {
                title: "杭州市上城区事业单位公开招聘网上报名系统"
              }
            },
            // 缴费
            {
              path: "/apply/applyPayForExam",
              name: "PayForExam",
              component: () => import("@/view/apply/applyPages/PayForExam"),
              meta: {
                title: "杭州市上城区事业单位公开招聘网上报名系统"
              }
            },
            // 打印准考证
            {
              path: "/apply/applyPrintAdmission",
              name: "PrintAdmission",
              component: () => import("@/view/apply/applyPages/PrintAdmission"),
              meta: { keepAlive: true, title: "杭州市上城区事业单位公开招聘网上报名系统" }
            },
            // 公布成绩
            {
              path: "/apply/applyAnnounceResults",
              name: "AnnounceResults",
              component: () =>
                import("@/view/apply/applyPages/AnnounceResults"),
              meta: { keepAlive: true, title: "杭州市上城区事业单位公开招聘网上报名系统" }
            }
          ]
        },
        {
          path: "/apply/personalExam",
          name: "PersonalExam",
          component: () => import("@/view/apply/PersonalExam"),
          meta: {
            title: "杭州市上城区事业单位公开招聘网上报名系统"
          }
        }
      ]
    }
  ]
});

// 挂载导航守卫
router.beforeEach((to, from, next) => {
  console.log(to);
  if (to.path == "/apply/examInfo" && to.query.examId) {
    next();
    return;
  }
  console.log("123");
  if (to.path == "/login" || to.path == "/register") {
    next();
    return;
  }
  const tokenStr = window.sessionStorage.getItem("applyToken");
  if (!tokenStr) {
    return next("/login");
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js